import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import { ShoppingBag } from 'lucide-react'
import { cn } from '@/lib/utils'
import LinkButton from '@/components/controls/link-button'
import CmsText from '@/components/generals/cms-text'
import LogoLink from '@/components/generals/logo-link'

const Header: FC = (): ReactNode => {
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 16)

        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })

        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    return (
        <motion.header
            id='header'
            initial={{ y: -24, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className={cn(
                'sticky top-0 z-40 transition-all duration-300',
                scrolled
                    ? 'bg-brand-cream/85 backdrop-blur-md shadow-[0_8px_24px_-12px_rgba(0,0,0,0.12)]'
                    : 'bg-transparent'
            )}
        >
            <div className='container-page flex h-16 items-center justify-between md:h-20'>
                <LogoLink>
                    <Image
                        src='/logo-on-white.svg'
                        alt='Dhurata e Bajramit'
                        width={303}
                        height={61}
                        preload
                        className='h-9 w-auto md:h-10'
                    />
                </LogoLink>

                <LinkButton href='/#porosit' variant='red' size='md'>
                    <CmsText textKey='header.ctaOrder' />
                    <ShoppingBag aria-hidden className='h-4 w-4' />
                </LinkButton>
            </div>
        </motion.header>
    )
}

export default Header
